import { Canvas, View } from '@react-pdf/renderer';

const SubLine = ({ lineWidth, lineHeight, color = '#002D62', width = 1, style, flag = false }) => {
  if (flag) {
    return (
      <Canvas
        style={{ width: lineWidth, height: lineHeight, ...style }}
        paint={(painter, maxWidth, height) => {
          const centerY = height / 2;
          painter
            .moveTo(0, centerY)
            .lineTo(maxWidth, centerY)
            .lineWidth(width)
            .strokeColor(color)
            .stroke();
        }}
      />);
  }
  return (<View style={{ marginLeft: 5, height: 1, backgroundColor: color, flex: 1 }} />);
};
export default SubLine;